module.exports = __webpack_public_path__ + "img/00025.6ed2b401.webp";